import { ILanguage } from "src/consts/locale";
import { formatRangeSliderNumber } from "src/hooks/formatters/number-formatter";

export const getNumberFromInputString = (value: string, thousandSeparator: string) =>
    parseFloat(value.replaceAll(thousandSeparator, "").replace(",", "."));

export const getInputValueFromRange = (language: ILanguage, rangeValue: number, steps: number[], showPositiveLeadingSign: boolean) =>
    formatRangeSliderNumber({ language, value: steps[rangeValue], showPositiveLeadingSign });

export const getRangeIndexFromInput = (inputValue: number, steps: number[]) => {
    const closestStep = steps.reduce((a, b) => (Math.abs(b - inputValue) < Math.abs(a - inputValue) ? b : a));
    return steps.indexOf(closestStep);
};

const numberInputRegex = /^[-+]?[0-9.,]*$/;
export const isInputValid = (value: string) => numberInputRegex.test(value);

export const getInputPaddingRight = (language: ILanguage = "en", shouldShowPercentageLabel: boolean) => {
    if (shouldShowPercentageLabel) {
        return language === "de" ? "36px" : 4;
    } else {
        return 2;
    }
};

export const shouldNegateInputNumber = (currentInputValue: number, defaultMaxInputValue: number) =>
    !isNaN(currentInputValue) && defaultMaxInputValue <= 0 && currentInputValue > 0;
